<template>
  <div id="residence-gallery-app" >
    <GalleryWrapper v-if="residenceData" :pictures="pictures" :prestations="prestations" />
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import GalleryWrapper from "./components/GalleryWrapper.vue";
import * as _ from "lodash"



export default {
  name: "App",
  components: {
    GalleryWrapper,
  },
  setup() {
    const residenceData = ref(null);
    const pictures = ref([]);
    const prestations = ref([]);

    const handleSeasonPictures = (data) => {
      const seasonFromURL = new URLSearchParams(window.location.hash.substring(1)).get("season");
      if(!seasonFromURL) throw new Error("No 'season' found in the URL")

      let seasonPictures = seasonFromURL === "H" ? data.picturesLodgingWinter : data.picturesLodgingSummer;
      if (seasonPictures.length < 5) {
        const additionalPictures = data.picturesLodging
          .filter((pic) => !seasonPictures.some((seasonPic) => seasonPic.img === pic.img))
          .slice(0, 5 - seasonPictures.length);

        seasonPictures = [...seasonPictures, ...additionalPictures];
      }
      return seasonPictures
    };

    const handleAvailablePrestations = (pictures) => {
      if(!window.lihe.availablePrestations) throw new Error("No 'availablePrestations' found in the window.lihe")
      const availablePrestations = _.cloneDeep(window.lihe.availablePrestations)

      availablePrestations.unshift({
        accomodationName: "Residence",
        picturesAccomodation: pictures,
      });

      return availablePrestations
    };

    onMounted(() => {
        
        if(!window.lihe) throw new Error("No lihe found in the window object")
        const data = _.cloneDeep(window.lihe)
        residenceData.value = data;

        pictures.value = handleSeasonPictures(data);
        prestations.value = handleAvailablePrestations(pictures.value );
        
        window.addEventListener("availableImagesBuilt" , () => {
          pictures.value = handleSeasonPictures(data);
          prestations.value = handleAvailablePrestations(pictures.value );
        })

    });


    return {
      residenceData,
      pictures,
      prestations,
      handleSeasonPictures,
      handleAvailablePrestations,
    };
  },
};
</script>

<style scoped>
</style>